import PropTypes from 'prop-types';
import { Component } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { RemoveIcon, SuccessIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import RequestStatus from '../../constants/edit/RequestStatus';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class SaveStatus extends Component {
  getSaveInfoTooltip() {
    const {
      onVersionHistoryClick
    } = this.props;
    return /*#__PURE__*/_jsx(Text, {
      color: "text-inverse-default",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "knowledgeContentUI.edit.saveStatus.saveInfoTooltip_jsx",
        elements: {
          Link: linkProps => /*#__PURE__*/_jsx(Link, {
            onClick: onVersionHistoryClick,
            children: linkProps.children
          })
        }
      })
    });
  }
  getLastSavedString() {
    const {
      article
    } = this.props;
    const {
      authorName_temp: authorName,
      values: {
        hs_updated_at
      }
    } = article;
    const updatedAt = I18n.moment(Math.min(hs_updated_at || 0, new Date().valueOf())).format('llll');
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.edit.saveStatus.updated",
      options: {
        authorName,
        updatedAt
      }
    });
  }
  renderFailedStatus() {
    return /*#__PURE__*/_jsx("span", {
      "data-test-id": "article-save-status-failed",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(View, {
          as: "span",
          marginInlineEnd: "100",
          children: /*#__PURE__*/_jsx(RemoveIcon, {
            color: "fill-primary-default",
            size: "300"
          })
        }), /*#__PURE__*/_jsx(Text, {
          typography: "detail-100",
          color: "text-inverse-default",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.edit.saveStatus.error"
          })
        })]
      })
    });
  }
  renderPendingStatus() {
    return /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      "data-test-id": "article-save-status-pending",
      children: [/*#__PURE__*/_jsx(LoadingSpinner, {
        size: "extra-small",
        use: "success",
        marginInlineEnd: "100"
      }), /*#__PURE__*/_jsx(Text, {
        color: "text-inverse-default",
        typography: "detail-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.edit.saveStatus.saving"
        })
      })]
    });
  }
  renderSucceededStatus() {
    return /*#__PURE__*/_jsx(Tooltip, {
      placement: "bottom",
      title: this.getLastSavedString()
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      ,
      zIndex: parseInt(1211, 10),
      children: /*#__PURE__*/_jsx("span", {
        "data-test-id": "article-save-status-succeeded",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(View, {
            as: "span",
            marginInlineEnd: "100",
            children: /*#__PURE__*/_jsx(SuccessIcon, {
              color: "fill-positive-default",
              size: "300"
            })
          }), /*#__PURE__*/_jsx(Text, {
            typography: "detail-100",
            color: "text-inverse-default",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "knowledgeContentUI.edit.saveStatus.saved"
            })
          })]
        })
      })
    });
  }
  renderNoUnsavedChangesStatus() {
    return /*#__PURE__*/_jsx(Tooltip, {
      placement: "bottom",
      title: this.getLastSavedString()
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      ,
      zIndex: parseInt(1211, 10),
      children: /*#__PURE__*/_jsx(Text, {
        color: "text-inverse-default",
        typography: "detail-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.edit.saveStatus.noUnsavedChanges"
        })
      })
    });
  }
  renderStatus(status) {
    switch (status) {
      case RequestStatus.PENDING:
        return this.renderPendingStatus();
      case RequestStatus.SUCCEEDED:
        return this.renderSucceededStatus();
      case RequestStatus.FAILED:
        return this.renderFailedStatus();
      case RequestStatus.UNINITIALIZED:
        return this.renderNoUnsavedChangesStatus();
      default:
        return null;
    }
  }
  render() {
    const {
      status
    } = this.props;
    return /*#__PURE__*/_jsx(Text, {
      typography: "detail-100",
      children: this.renderStatus(status)
    });
  }
}
SaveStatus.propTypes = {
  onVersionHistoryClick: PropTypes.func.isRequired,
  status: PropTypes.oneOf([RequestStatus.UNINITIALIZED, RequestStatus.PENDING, RequestStatus.SUCCEEDED, RequestStatus.FAILED])
};
export default SaveStatus;